import { SURVEY_REQUEST } from '../actions/constants'; 

const trends = (state = {} , action) => {
  switch (action.type) {
    case SURVEY_REQUEST : {
      const newState = Object.assign({},state,{
        survey : action.payload
      })
      return newState;
    }
    default:
      return state;
  }
};
  
export default trends;
  